import type { SimpleFilter } from '@/sections/insights/queryBuilder/entities/types';
import type { Operator, QueryFilter } from '@/types';

import { invertMap } from './invert';

const defaultNotMap: Record<string, string> = {
  is: 'is not',
  'is any of': 'is none of',
  contains: 'does not contain',
  'starts with': 'does not start with',
  'ends with': 'does not end with',
};

const defaultNotMapInverse: Record<string, string> = invertMap(defaultNotMap);

const defaultOperatorMap: Record<string, string> = {
  '=': 'is',
  IN: 'is any of',
  CONTAINS: 'contains',
  'STARTS WITH': 'starts with',
  'ENDS WITH': 'ends with',
};

const defaultOperatorMapInverse: Record<string, string> =
  invertMap(defaultOperatorMap);

export const getOperatorFromSimpleFilter = (
  simpleFilter: SimpleFilter,
  operatorMap: Record<string, string> = defaultOperatorMapInverse,
  notMap: Record<string, string> = defaultNotMapInverse
): Operator => {
  var operator = simpleFilter.operator;
  if (notMap[operator]) {
    operator = notMap[operator];
  }

  return (operatorMap[operator] || simpleFilter.operator) as Operator;
};

export const getOperatorFromQueryFilter = (
  queryFilter: QueryFilter,
  operatorMap: Record<string, string> = defaultOperatorMap,
  notMap: Record<string, string> = defaultNotMap
): string => {
  var operator = operatorMap[queryFilter.operator] || queryFilter.operator;
  if (notMap && notMap[operator] && queryFilter.not === true) {
    operator = notMap[operator];
  }

  return operator;
};

export const getValueFromSimpleFilter = (
  valueMap: Record<string, string | boolean>,
  simpleFilter: SimpleFilter
): QueryFilter['value'] => {
  return Array.isArray(simpleFilter.value)
    ? simpleFilter.value.map(v => valueMap[v] ?? v)
    : (valueMap[simpleFilter.value] ?? simpleFilter.value);
};

export const getValueFromQueryFilter = (
  valueMap: Record<string, string>,
  queryFilter: QueryFilter
): string | string[] => {
  return Array.isArray(queryFilter.value)
    ? (queryFilter.value as string[]).map(v => valueMap[v] || v)
    : valueMap[queryFilter.value as string] || (queryFilter.value as string);
};

export const getNotFromSimpleFilter = (
  simpleFilter: SimpleFilter,
  notMap: Record<string, string> = defaultNotMapInverse
): boolean => {
  if (notMap[simpleFilter.operator]) {
    return true;
  }

  return false;
};
